module.exports = __webpack_public_path__ + "static/RotatePhoneImage2-45ab6d95d9e5aa5226c8c0a4ebedea84.png";